module.exports = __webpack_public_path__ + "img/verified.7258d7f1.png";